class DynamicVideoCarousel extends HTMLElement {
  constructor() {
    super();
    this.container = this.closest('.video-walkthrough .container');
    this.videos = document.querySelectorAll('.audio-demo .swiper-wrapper video');
    this.carouselSelect = document.querySelector('.carousel-select');
    this.activeDaw = document.querySelector('.carousel-wrapper:not(.hidden) .audio-demo');
    this.slider = null;
    this.addListeners = this.addListeners.bind(this);
    this.initSlider = this.initSlider.bind(this);
    this.handleCarouselChange = this.handleCarouselChange.bind(this);
    this.addListeners();
    this.initObserver();

    if (this.activeDaw) {
      this.initSlider(this.activeDaw);
    }
  }

  addListeners() {
  // 1) Pause any other site audio as soon as the user interacts with the carousel
  //    (capture = runs even if Swiper/overlays interfere with normal bubbling)
  const killExternalAudio = () => this.pauseExternalAudio();

  this.addEventListener('pointerdown', killExternalAudio, true);
  this.addEventListener('click', killExternalAudio, true);

  // 2) Keep your existing per-video click handler
  this.videos.forEach(video => {
    video.addEventListener('click', (event) => {
      this.handleVideoClick(event);
    });
  });

  this.carouselSelect.addEventListener('change', this.handleCarouselChange);

  // 3) Existing "pause all videos" event
    document.addEventListener('videos:pause', () => {
  [...document.querySelectorAll('.audio-demo .swiper-wrapper video')].forEach((video) => {
    try { video.pause(); } catch (e) {}

    // iOS Safari can throw if you set currentTime before metadata is ready.
    // Only reset time if we have *some* readiness.
    try {
      if (video.readyState > 0) video.currentTime = 0;
    } catch (e) {}
  });
});

}

pauseExternalAudio() {
  const evtOpts = { bubbles: true, composed: true };

  // 1) Dispatch your existing pause events (keep these)
  const events = [
    'product:audio:pause',
    'soundbar:pause',
    // extra common variants (safe no-ops if nothing listens)
    'audio:pause',
    'media:pause',
    'pause:all'
  ];

  events.forEach((name) => {
    try { document.dispatchEvent(new Event(name, evtOpts)); } catch (e) {}
    try { window.dispatchEvent(new Event(name, evtOpts)); } catch (e) {}
  });

  // 2) Stop Howler (many Shopify audio demos use it)
  try {
    if (window.Howler && typeof window.Howler.stop === 'function') {
      window.Howler.stop();
    }
  } catch (e) {}

  // 3) Hard-stop all audio/video in the light DOM AND in any OPEN shadow roots
    const stopMediaInRoot = (root) => {
    if (!root || !root.querySelectorAll) return;

    const isInsideThisCarousel = (el) => {
      try { return !!el.closest && !!el.closest('dynamic-video-carousel'); } catch (e) { return false; }
    };

    // Stop + reset AUDIO (safe to reset)
    root.querySelectorAll('audio').forEach((a) => {
      try {
        a.pause();
        a.currentTime = 0;
      } catch (e) {}
    });

    // Stop VIDEOS that are NOT inside the dynamic video carousel
    // (do NOT reset time; we only want to stop playback, not restart)
    root.querySelectorAll('video').forEach((v) => {
      if (isInsideThisCarousel(v)) return;
      try {
        v.pause();
      } catch (e) {}
    });

    // Traverse open shadow roots
    root.querySelectorAll('*').forEach((el) => {
      if (el.shadowRoot) stopMediaInRoot(el.shadowRoot);
    });
  };

  stopMediaInRoot(document);

}




  handleVideoClick(event) {
    const video = event.target;
    const parent = video.closest('.swiper-slide');

    if (video.tagName !== 'VIDEO') {
      return;
    }

    if (parent.classList.contains('swiper-slide-active')) {
      const videos = document.querySelectorAll('.swiper-slide:not(.swiper-slide-active) video:not(.loaded)');

      if (video.paused) {
        parent.classList.add('playing');

        video.play().catch(err => {
          console.warn("Video playback blocked:", err);
        });

        const pauseProductAudioEvent = new Event('product:audio:pause');
        const pauseSoundbarAudioEvent = new Event('soundbar:pause');
        document.dispatchEvent(pauseProductAudioEvent);
        document.dispatchEvent(pauseSoundbarAudioEvent);
      } else {
        parent.classList.remove('playing');
        video.pause();
      }

      videos.forEach((video) => {
        video.classList.add('loaded');
      });
    }
  }

  handleCarouselChange(event) {
    const selectedOption = event.target;
    const selectedFormat = selectedOption.options[selectedOption.selectedIndex].dataset.format;
    const carousels = document.querySelectorAll('.carousel-wrapper');
    let selectedCarousel = document.querySelector(`.carousel-wrapper[data-format="${selectedFormat}"]`);

    let updateSelectedFormatEvent = new CustomEvent('format:update', {
      detail: {
        selected: selectedFormat
      }
    });
    document.dispatchEvent(updateSelectedFormatEvent);

    carousels.forEach(function (carousel) {
      carousel.classList.add('hidden');
    });
    selectedCarousel.classList.remove('hidden');

// iOS Safari: when swapping hidden -> visible, force videos in the newly shown carousel to initialize
selectedCarousel.querySelectorAll('video').forEach((v) => {
  try {
    // keep metadata preload, but force Safari to re-evaluate sources/poster
    v.preload = 'metadata';
    v.load();
  } catch (e) {}
});


    const carouselBarImage = document.querySelector('.carousel-bar__image');
    const carouselBarImageSrc = selectedOption.options[selectedOption.selectedIndex].getAttribute('data-image');
    carouselBarImage.setAttribute('src', carouselBarImageSrc);

    let pauseVideosEvent = new Event('videos:pause');
    document.dispatchEvent(pauseVideosEvent);

    this.initSlider(selectedCarousel.querySelector('.audio-demo'));
    this.initObserver();
  }

  lazyLoadImages(entries, observer) {
    const daw = document.querySelector('.carousel-wrapper:not(.hidden) .daw');
    const audioDemo = daw.querySelector('.audio-demo');
    const images = daw.querySelectorAll('.carousel-wrapper:not(.hidden) .video-wrap img');
    const loadingSpinner = daw.querySelector('.loading-spinner');

    entries.forEach(entry => {
      if (entry.isIntersecting) {
        images.forEach(img => {
          setImageSources(img);
        });
        observer.disconnect();
        loadingSpinner.classList.add('loading-spinner--out');
        audioDemo.classList.add('show');
      }
    });


  }

  initObserver() {
    const dawWrapper = document.querySelector('.carousel-wrapper:not(.hidden)')
    const observer = new IntersectionObserver(this.lazyLoadImages, {
      root: null,
      rootMargin: '0px',
      threshold: 0.1
    });

    observer.observe(dawWrapper);

// iOS: if it's already on-screen, IntersectionObserver may not fire until scroll.
// Manually trigger the lazy-load behavior once.
try {
  const r = dawWrapper.getBoundingClientRect();
  const inView = r.top < window.innerHeight && r.bottom > 0;
  if (inView) {
    this.lazyLoadImages([{ isIntersecting: true }], observer);
  }
} catch (e) {}

  }

  initSlider(slider) {
    const slides = slider.querySelectorAll('.swiper-slide');
    if (this.slider) {
  try { this.slider.destroy(true, true); } catch (e) {}
  this.slider = null;
}

    const swiper = new Swiper(slider, {
      effect: 'coverflow',
      centeredSlides: true,
      slidesPerView: 'auto',
      initialSlide: 1,
      longSwipesRatio: 0.05,
      slideToClickedSlide: false,
      slideVisibleClass: 'slide-active',
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 100,
        modifier: 3.5,
        slideShadows: true,
      },
      navigation: {nextEl: '.next', prevEl: '.prev'},
      loop: false,
      lazyPreloadPrevNext: 6,
      touchStartPreventDefault: false,
      passiveListeners: false,
      preventClicks: true,
      preventClicksPropagation: true,
      focusableElements: 'input, select'
    });

    this.slider = swiper;

    const primeVideo = (v) => {
  if (!v) return;

  // Only do this once per video element
  if (v.dataset.primed === '1') return;

  // Warm the network/buffer without forcing full download
  v.preload = 'metadata';
  try { v.load(); } catch (e) {}

  v.dataset.primed = '1';
};

// Prime first visible set (active + a couple neighbors)
const primeAroundIndex = (idx) => {
  const slideEls = swiper.el.querySelectorAll('.swiper-slide');
  const radius = 2; // try 2 first; increase to 3 if needed
  for (let i = idx - radius; i <= idx + radius; i++) {
    const el = slideEls[i];
    if (!el) continue;
    primeVideo(el.querySelector('video'));
  }
};


    swiper.on('init', function () {
  swiper.classList.add('show');

  // Prime upcoming videos once Swiper is ready
  if (typeof primeAroundIndex === 'function') {
    primeAroundIndex(swiper.realIndex);
  }
});


    slides.forEach((slide) => {
      const video = slide.querySelector('video');
if (!video || video.dataset.wshBound === '1') return;
video.dataset.wshBound = '1';


      video.controls = false;

      if (!slide.classList.contains('swiper-slide-active')) {
        video.pause();
      }

      video.addEventListener('ended', function () {
        if (!this.muted) {
          if (!swiper.slideNext(300, true)) {
            swiper.slideTo(0, 300, true);
          }
        }
      });

      video.addEventListener('loadeddata', function () {
  const wrap = video.closest('.video-wrap');
  const img = wrap ? wrap.querySelector('img') : null;

  video.classList.remove('hidden');

  if (img) {
    // Hide instead of remove to avoid layout/paint flash
    img.style.opacity = '0';
    img.style.transition = 'opacity 120ms linear';
    img.style.pointerEvents = 'none';
  }
}, { once: true });



      video.addEventListener('play', function () {
        const parentSlide = this.closest('.swiper-slide');
        if (parentSlide.classList.contains('swiper-slide-active')) {
          const audioDemoHelp = document.querySelector('.audio-demo-help');
          if (audioDemoHelp) {
            audioDemoHelp.classList.toggle('is-playing', !this.muted);
          }
        }

        // Pause all audios
        const pauseProductAudioEvent = new Event('product:audio:pause');
        const pauseSoundbarAudioEvent = new Event('soundbar:pause');
        document.dispatchEvent(pauseProductAudioEvent);
        document.dispatchEvent(pauseSoundbarAudioEvent);
      });

      video.addEventListener('timeupdate', function () {
        const thisVideo = this;
        const parent = thisVideo.closest('.swiper-slide');

        if (!parent.classList.contains('swiper-slide-active')) {
          return;
        }

        if (
          thisVideo.muted ||
          thisVideo.readyState !== 4 ||
          thisVideo.networkState !== 1 ||
          thisVideo.paused
        ) {
          return;
        }
      });
    });

    swiper.on('slideChange', function () {
      const previousSlideElement = this.el.querySelectorAll('.swiper-slide')[this.previousIndex];
      const activeSlideElement = this.el.querySelectorAll('.swiper-slide')[this.realIndex];

      if (!previousSlideElement && !activeSlideElement) {
        return;
      }

      const previousVideo = previousSlideElement.querySelector('video');
      const activeVideo = activeSlideElement.querySelector('video');

// Prime upcoming videos around the current slide
if (typeof primeAroundIndex === 'function') {
  primeAroundIndex(this.realIndex);
}


      if (typeof previousVideo !== 'undefined') {
        if (!previousVideo.paused || previousVideo.ended) {
          previousVideo.pause();
          previousVideo.currentTime = 0;
          activeVideo.muted = false;
          activeVideo.currentTime = 0;
          activeVideo.play();
          activeSlideElement.classList.add('playing');
          previousSlideElement.classList.remove('playing');
        } else {
          previousSlideElement.classList.remove('playing');
          previousVideo.pause();
          previousVideo.currentTime = 0;
        }
      }

      if (activeVideo.paused) {
        activeSlideElement.classList.remove('playing');
      }
    });

    // After swiper.init() or inside swiper.on('init')
primeAroundIndex(swiper.realIndex);

    swiper.init();


/* iOS: after viewport/UI settles, recompute coverflow so side slides remain visible */
setTimeout(() => {
  try {
    swiper.update();
    swiper.updateSlides();
    swiper.updateProgress();
    swiper.updateSize();
    swiper.updateSlidesClasses();
  } catch (e) {}
}, 300);

/* Also recompute on orientation / resize */
window.addEventListener('resize', () => {
  try {
    swiper.update();
  } catch (e) {}
}, { passive: true });

  }
}

customElements.define('dynamic-video-carousel', DynamicVideoCarousel);